/**
 * CLS-FI legal copy for Terms & Conditions and Privacy Policy.
 * Overrides the shared (Danish) content in Clothing/Common/HelpCenter/legalContent.js.
 * FI-TODO: the Finnish texts are not written yet — a short notice is shown instead of
 * the Danish ones until the brand supplies them.
 */

export const TERMS_TITLE = 'Kauppaehdot';

export const TERMS_SECTIONS = [
  {
    blocks: [
      { type: 'p', text: 'Kauppaehdot päivitetään pian. Jos sinulla on kysyttävää, ota meihin yhteyttä: info@clseifert.fi.' },
    ],
  },
];

export const PRIVACY_TITLE = 'Tietosuojakäytäntö';

export const PRIVACY_SECTIONS = [
  {
    blocks: [
      { type: 'p', text: 'Tietosuojakäytäntö päivitetään pian. Jos sinulla on kysyttävää henkilötietojesi käsittelystä, ota meihin yhteyttä: info@clseifert.fi.' },
    ],
  },
  {
    title: 'Tekoälyavustaja hallintajärjestelmässämme (Anthropic)',
    blocks: [
      {
        type: 'p',
        text: 'Työntekijämme voivat käyttää sisäisessä hallintajärjestelmässämme tekoälyavustajaa esimerkiksi vastatessaan tilauksia, tuotteita ja koulukauppoja koskeviin kysymyksiin. Avustajan toimittaa Anthropic (Claude). Kun työntekijä esittää avustajalle kysymyksen, joka sitä edellyttää, tilauksesi tietoja voidaan lähettää Anthropicille: nimi, yhteystiedot, toimitusosoite, koulu ja luokka sekä tilauksen sisältö, maksun ja toimituksen tila. Avustaja näkee vain ne tiedot, joihin kyseisellä työntekijällä itsellään on pääsy.',
      },
      {
        type: 'p',
        text: 'Anthropic käsittelee tietoja henkilötietojen käsittelijänä puolestamme eikä saa käyttää niitä omiin tarkoituksiinsa, esimerkiksi tekoälymallien kouluttamiseen. Tietoja käsitellään Yhdysvalloissa; siirto perustuu Euroopan komission vakiosopimuslausekkeisiin, jotka sisältyvät Anthropicin kanssa tekemäämme tietojenkäsittelysopimukseen. Käsittelyn oikeusperuste on oikeutettu etumme tarjota nopeaa ja täsmällistä asiakaspalvelua ja hallinnointia (tietosuoja-asetuksen 6 artiklan 1 kohdan f alakohta). Lisätietoja Anthropicin tietosuojakäytännössä: https://www.anthropic.com/legal/privacy',
      },
    ],
  },
];
